import { Route, Routes } from "react-router-dom"
import AuthLayout from "../Layouts/AuthLayout"
import Login from "../Pages/Auth/login/Login";
import SignUp from "../Pages/Auth/signup/Signup";
import Confirm from "../Pages/Auth/confirm/confirm";
import ResetPassword from "../Pages/Auth/reset-password/reset-password";

const AuthPage = () => (
    <Routes>
        <Route element={<AuthLayout/>}>
            <Route path="login" element={<Login/>} />
            <Route path="register" element={<SignUp/>} />
            <Route path="confirm" element={<Confirm/>} />
            <Route path="forgot-password" element={<Login/>} />
            <Route path="reset-password" element={<ResetPassword/>} />
            <Route index element={<Login />} />
        </Route>
    </Routes>
)

export default AuthPage;